import qs from "qs";

export class AddressClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/addresses`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getZipCode(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/zip_code${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getAmphur(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/amphur${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}
